/** Canonical seller dashboard login — dm2order.in is storefront only. */
export const PRODINENT_SELLER_LOGIN_URL = 'https://prodinent.com/login';

export function normalizeHost(hostname) {
  return String(hostname || '')
    .split(',')[0]
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, '');
}

export function isDm2OrderHost(hostname) {
  const host = normalizeHost(hostname);
  return host === 'dm2order.in' || host === 'www.dm2order.in';
}

/** True only for /login (case-insensitive, optional trailing slash). */
export function isDm2LoginPath(pathname) {
  const path = String(pathname || '').replace(/\/+$/, '') || '/';
  return path.toLowerCase() === '/login';
}

export function buildProdinentLoginRedirectUrl(search = '', hash = '') {
  return `${PRODINENT_SELLER_LOGIN_URL}${search || ''}${hash || ''}`;
}

/**
 * Redirect dm2order.in/login → prodinent.com/login (query + hash preserved).
 * @returns {boolean} true if redirect was triggered
 */
export function redirectDm2LoginToProdinent(location = window.location) {
  if (!location || typeof location.replace !== 'function') return false;
  if (!isDm2OrderHost(location.hostname)) return false;
  if (!isDm2LoginPath(location.pathname)) return false;

  location.replace(buildProdinentLoginRedirectUrl(location.search, location.hash));
  return true;
}

export function getDm2LoginRedirectUrl(host, pathname, search = '', hash = '') {
  if (!isDm2OrderHost(host)) return null;
  if (!isDm2LoginPath(pathname)) return null;
  return buildProdinentLoginRedirectUrl(search, hash);
}
